import React from 'react';

export const MLWizardDataSnapshotContext = React.createContext();
